import { parseUtc } from '~/composables/support/localization'
import { isAfter } from 'date-fns'
import type { ContractReadyForPurchase } from '~/resources/graphql/graphql'
import { ContractReadyForPurchase as ContractReadyForPurchaseEnum } from '../../../resources/app/generated/enums'

export function getEditingActiveSection(
    draftExpiresAtUtc: string | null,
    readyForPurchase: ContractReadyForPurchase
) {
    if (readyForPurchase === ContractReadyForPurchaseEnum.COURSE_CANCELLED) {
        return 0
    }

    // If the contract we are editing has expired, start from beginning
    if (draftExpiresAtUtc !== null) {
        const expiresAtUtc = parseUtc(draftExpiresAtUtc)
        if (isAfter(new Date(), expiresAtUtc)) {
            return 0
        }
    }

    // If the contract is ready for purchase or only missing the document,
    // start after participant details
    if (
        readyForPurchase === 'VALID' ||
        readyForPurchase === 'INCOMPLETE_DOCUMENT'
    ) {
        return 2
    }
    // Else start from participant details
    else {
        return 1
    }
}
